<template>
  <div class="addressDetails">
    <div>
      <module-title title="收货地址">
        <div class="right">
          <el-button type="primary" size="medium" icon="el-icon-arrow-left" @click="$emit('close')">
            返回
          </el-button>
        </div>
      </module-title>
      <div>
        <el-form
          ref="subjectSearchForm"
          :model="searchForm"
          :inline="true"
          label-position="right"
        >
          <el-form-item label="标签：" prop="isDefault">
            <el-select
              v-model="searchForm.isDefault"
              name="isDefault"
              size="medium"
              class="edit-form-input"
            >
              <el-option :key="null" label="全部" :value="null" />
              <el-option
                v-for="item in isDefaultList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="选择省/市/区县：" prop="areaCode">
            <el-cascader
              v-model="searchForm.areaCode"
              :options="areaData"
              :props="areaProps"
              clearable
              placeholder="选择省/市/区县"
              @change="handleChangeArea"
            />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-search"
              @click="handleSearchFilter"
            >
              查询
            </el-button>
          </el-form-item>
        </el-form>
        <el-table
          v-loading="listLoading"
          :data="addressList"
          highlight-current-row
          fit
          element-loading-text="Loading"
          class="list-table"
        >
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="省" align="center" prop="provinceName" />
          <el-table-column label="市" prop="cityName" align="center" />
          <el-table-column label="区" prop="areaName" align="center" />
          <el-table-column label="街道" prop="townName" align="center" />
          <el-table-column label="详细地址" prop="detailedAddress" align="center" />
          <el-table-column label="标签" prop="isDefault" align="center">
            <template slot-scope="scope">
              <span v-show="scope.row.isDefault">默认地址</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="searchForm.total"
          :page.sync="searchForm.pageNum"
          :limit.sync="searchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>

import { getUsersAddressList } from '@/api/userManagement/index/';
import { mapGetters } from 'vuex';
import {
  getDictsType
} from '@/api/productOperation/public/advertisementManage';
export default {
  name: 'ShippingAddress',
  props: {
    userProps: {
      default: Object,
      type: Object
    }
  },

  data() {
    return {
      dictsType: 'user_source',
      // 搜索表单
      searchForm: {
        productTerminal: null,
        advertisementPosition: null,
        advertisementType: null,
        pageNum: 1,
        total: 0,
        pageSize: 10,
        areaCode: null
      },
      addressList: [],
      appCodeList: [],
      areaProps: {
        value: 'code',
        label: 'name',
        children: 'children',
        checkStrictly: true
      },
      listLoading: false // 表格刷新loading
    };
  },
  computed: {
    ...mapGetters(['areaData']),
    isDefaultList() {
      return [
        {
          id: 1,
          name: '是默认地址'
        },
        {
          id: 0,
          name: '不是默认地址'
        }
      ];
    }

  },
  watch: {
    // 属性监听
    userProps: {
      handler: function(val, oldVal) {
        this.fetchAddressList();
      },
      immediate: true
    }
  },
  mounted() {
    this.$store.dispatch('getNodes');
    this.getType();
    this.fetchAddressList();
  },
  methods: {
    getType() {
      getDictsType(this.dictsType).then(res => {
        this.appCodeList = res.data;
      });
    },

    // 获取积分明细数据
    fetchAddressList() {
      this.listLoading = true;
      var options = {
        accountId: this.userProps.accountId,
        appCode: this.searchForm.appCode,
        isDefault: this.searchForm.isDefault,
        provinceCode: this.searchForm.provinceCode,
        cityCode: this.searchForm.cityCode,
        areaCode: this.searchForm.areaCode,
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      };
      getUsersAddressList(options).then((res) => {
        if (res.data && res.data.list && res.data.list.length) {
          this.addressList = res.data.list;
          this.searchForm.total = res.data.total;
        } else {
          this.addressList = [];
          this.searchForm.total = 0;
        }
        this.listLoading = false;
      }).catch((err) => {
        console.log(err);
        this.addressList = [];
        this.total = 0;
        this.listLoading = false;
      });
    },
    handleChangeArea(val) {
      if (val.length > 0) {
        this.searchForm.provinceCode = val[0] ? val[0] : null;
        this.searchForm.cityCode = val[1] ? val[1] : null;
        this.searchForm.areaCode = val[2] ? val[2] : null;
      } else {
        this.searchForm.provinceCode = null;
        this.searchForm.cityCode = null;
        this.searchForm.areaCode = null;
      }
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchAddressList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchAddressList();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.fetchAddressList();
    }
  }
};
</script>
<style lang="scss" scoped>
.addressDetails {
  padding-bottom: 20px;
}
.edit-form-input {
  width: 160px;
}
</style>
